import { render, staticRenderFns } from "./ValidationField.vue?vue&type=template&id=0b97e82a&"
import script from "./ValidationField.vue?vue&type=script&lang=js&"
export * from "./ValidationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports